import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import React from 'react';

interface SubmitCandidatesPopupProps {
  open: boolean;
  onClose: () => void;
  selectedCandidates: Map<string, any>;
  isSubmitting: boolean;
  onConfirm: () => void;
  title?: string;
  subtitle?: string;
  confirmLabel?: string;
}

const SubmitCandidatesPopup: React.FC<SubmitCandidatesPopupProps> = ({
  open,
  onClose,
  selectedCandidates,
  isSubmitting,
  onConfirm,
  title = 'Review Candidates',
  subtitle = 'Review and confirm the candidates you want to submit.',
  confirmLabel = 'Confirm Submission',
}) => {
  const selectedList = Array.from(selectedCandidates.values());

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      className="submit-candidates-dialog">
      <DialogTitle className="dialog-title">
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="flex-start">
          <Box>
            <Typography variant="h6" className="title">
              {title} ({selectedCandidates.size} Selected)
            </Typography>
            <Typography variant="body2" className="subtitle">
              {subtitle}
            </Typography>
          </Box>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers className="dialog-content">
        <Box className="selected-candidates-list">
          {selectedList.map((item) => {
            const c = item.candidate;
            const name =
              `${String(c?.firstName || '')} ${String(
                c?.middleName || '',
              )} ${String(c?.lastName || '')}`.trim() || '-';
            const match = `${String(item?.matchPercentage || 0)}%`;
            const visa = c?.workStatus?.name || '-';
            const location =
              [c?.city, c?.state, c?.country].filter(Boolean).join(', ') || '-';
            const email = c?.email || '-';
            const phone = c?.phone || c?.mobileNumber || '-';

            return (
              <Box key={item.id} className="candidate-review-card">
                <Box className="badges-row">
                  {match && <span className="badge match">{match}</span>}
                  {visa && <span className="badge visa">{visa}</span>}
                  {c?.source && (
                    <span className="badge source">{c?.source || ''}</span>
                  )}
                </Box>
                <Box className="info-row">
                  <Checkbox checked={true} size="small" />
                  <Box className="name-status">
                    <Typography className="name">{name}</Typography>
                    {c?.benchStatus && (
                      <Box className="status-available">
                        <CheckCircleIcon className="check-icon" />
                        {c?.benchStatus || ''}
                        <span className="dot">•</span>
                        {c?.benchAvailability || ''}
                      </Box>
                    )}
                  </Box>
                </Box>
                <Typography className="contact-line">
                  {email} • {phone} • {location}
                </Typography>
              </Box>
            );
          })}
        </Box>
      </DialogContent>
      <DialogActions className="dialog-actions">
        <Button onClick={onClose} className="cancel-shortlist-btn">
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={isSubmitting}
          onClick={onConfirm}
          className="confirm-btn">
          {isSubmitting ? 'Processing...' : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SubmitCandidatesPopup;
